import { render, staticRenderFns } from "./cameraDetail.vue?vue&type=template&id=61f6b94b&scoped=true&"
import script from "./cameraDetail.vue?vue&type=script&lang=js&"
export * from "./cameraDetail.vue?vue&type=script&lang=js&"
import style0 from "./cameraDetail.vue?vue&type=style&index=0&id=61f6b94b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6b94b",
  null
  
)

export default component.exports